// extracted by mini-css-extract-plugin
export default {"formContainer":"character-editor_formContainer__e-PDA"};